
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AvisoAlCerrar from '@/mixins/AvisoAlCerrar';
import AvisoSinGuardar from '@/components/core/AvisoSinGuardar.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import TravelSelect from '@/components/inputs/TravelSelect.vue';
import ExtraServicePrices from '@/components/forms/ExtraServicePrices.vue';
import ExtraServiceService from '@/services/ExtraService';
import ExtraService from '@/models/extra_service';
import ApiHelper from '@/helpers/api-helper';
import ExtraServiceTypeSelect from '@/components/inputs/ExtraServiceTypeSelect.vue';
import TextEditor from '@/components/inputs/TextEditor.vue';
import ProviderSelect from '@/components/inputs/ProviderSelect.vue';

@Component({
	components: {
		AvisoSinGuardar,
		ProviderSelect,
		TextEditor,
		TravelSelect,
		ExtraServicePrices,
		ExtraServiceTypeSelect,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class ExtraServiceForm extends Mixins(AvisoAlCerrar) {
	@Prop({ default: null, required: false }) private edit_id;

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
		extraServicePrice: InstanceType<typeof ExtraServicePrices>;
	};

	private loading = false;
	private formTitle = '';
	private extra_service: ExtraService = new ExtraService();

	/** N-291 (T5b): con un servicio NUEVO la tabla de precios va sobre su copia (no hay `prices` que compartir). */
	loQueSeGuardaria() {
		const tabla: any = this.$refs.extraServicePrice;
		return JSON.stringify({
			...this.extra_service,
			extra_services_prices: tabla ? tabla.prices : this.extra_service.extra_services_prices,
		});
	}

	mounted() {
		if (this.edit_id) {
			this.loading = true;
			this.formTitle = 'Edit extra service';
			ExtraServiceService.get(this.edit_id)
				.then(res => {
					if (res.status === 200) {
						this.extra_service = res.data;
						this.loading = false;
						this.fotoSinCambios();
					}
				})
				.catch(error => {
					// N-291 (T5): antes no se capturaba; se quedaba «Cargando» sin avisar de nada.
					ApiHelper.handleErrors(error, {}, this.$bus);
				});
		} else {
			this.formTitle = 'New extra service';
			this.fotoSinCambios();
		}
	}

	/**
	 * N-301: la tabla va PRIMERO. Es su `validate()` quien pasa las tarifas a `extra_services_prices` (la API las manda
	 * en `prices`), y el `required` del formulario mira ese campo: al revés, la 1.ª pulsación fallaba sin decir nada.
	 * Si algo falta, se dice: las filas de la tabla esconden sus mensajes, así que el aviso nombra la tarifa y el campo.
	 */
	async validarTodo() {
		const tabla = this.$refs['extraServicePrice'];
		const validPrices = await tabla.validate();
		await this.$nextTick();
		const validForm = await this.$refs['obs'].validate();
		if (!validForm || !validPrices) {
			const partes = [...tabla.faltasVistas];
			if (!validForm) {
				partes.push('Revisa los campos marcados en rojo');
			}
			this.$bus.$emit('error', { message: `No se ha guardado. ${partes.join('. ')}.` });
		}
		return validForm && validPrices;
	}

	async create() {
		const component = this;
		if (await this.validarTodo()) {
			ExtraServiceService.create(this.extra_service)
				.then(res => {
					if (res.status === 201) {
						this.$emit('saved');
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
				});
		}
	}

	async update() {
		const component = this;
		if (await this.validarTodo()) {
			ExtraServiceService.update(this.extra_service)
				.then(res => {
					if (res.status === 200) {
						this.$emit('saved');
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
				});
		}
	}
}
